var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from '../../Components/Modals/Modal';
import { SwipeluxLogo } from '../OrderDetailsPage/styles';
import { Caption } from '../../Components/Footer/Caption';
import styles from './terms.module.css';
import { Button } from '../../Components/BaseComponents/Button';
import { Bank, Hand, Clock, Calculator } from './icons';
var config = [
    {
        icon: Bank,
        text: 'Transfer from your bank account only; transfers from third-party accounts will be cancelled and may incur fees.',
    },
    {
        icon: Calculator,
        text: 'The amount of crypto credited to your account will fluctuate according to the current exchange rate.',
    },
    {
        icon: Hand,
        text: 'Each transfer is subject to a minimum fee of 0.9%.',
    },
    {
        icon: Clock,
        text: 'Your crypto assets will be deposited into your account within 1-3 business days after the transfer is processed.',
    },
];
export var TermsModal = function (props) {
    return (_jsxs(Modal, __assign({ className: styles.modal, label: _jsx(SwipeluxLogo, {}) }, props, { children: [_jsxs("div", __assign({ className: styles.wrapper }, { children: [_jsxs("div", __assign({ className: styles.info }, { children: [_jsx("div", __assign({ className: styles.title }, { children: "Terms and conditions" })), config.map(function (item, index) {
                                var Icon = item.icon;
                                return (_jsxs("div", __assign({ className: styles.info_row }, { children: [_jsx("div", { children: _jsx(Icon, {}) }), _jsx("div", __assign({ className: styles.info_row_text }, { children: item.text }))] }), index));
                            })] })), _jsx("div", __assign({ style: { display: 'flex' } }, { children: _jsx(Button, { onClick: props.onClose, label: "Got it" }) }))] })), _jsx(Caption, {})] })));
};
